// Mock data for ZSTAMP - Zcash Shielded Assets on BNB Chain
// NOTE: All data here is MOCKED for the frontend teaser.
// Real wallet connection, real BSC burn tx and Zcash certificate will replace this later.

export const CHAIN = {
  name: "BNB Chain",
  short: "BSC",
  burnAddress: "0x000000000000000000000000000000000000dEaD",
  launchpad: "flap.sh",
  launchpadUrl: "https://flap.sh/board?lang=zh",
};

export const TOKEN = {
  name: "STAMP",
  symbol: "STAMP",
  minBurn: 200000,
  contract: "0x00000000000000000000000000000000000STAMP",
};

export const heroCertificate = {
  status: "CANCELLED",
  quantity: 1500000,
  token: "STAMP",
  deliveredTo: "t1P2GcxGhzeM5tPk3r3JsGh1tEVArD4C2fB",
  inscription: "b2cbded5c37c2cca8918a077a73e2ca349005efba046cee0866b34dd879c5acb",
  burnTx: "0x9a4f2c8b7e1d5a3f6c0b9e8d7a2f1c4b6e3d8a0f5c2b7e9d1a4f6c3b8e0d5a2f",
};

function avatar(seed) {
  return `https://api.dicebear.com/7.x/shapes/svg?seed=${encodeURIComponent(seed)}&backgroundType=gradientLinear`;
}

export const launchedCoins = [
  { symbol: "ZIDE", name: "Zidelined", age: "4m", quote: "BNB", price: "$0.001586", mc: "$1.59M", change: "+156.8%", up: true, img: avatar("Zidelined") },
  { symbol: "ZEAL", name: "Zero Exposure Anonymous Layer", age: "5m", quote: "BNB", price: "$0.0₃3464", mc: "$335.83K", change: "+7.36%", up: true, img: avatar("Zeal") },
  { symbol: "ZATO", name: "Zatoshi", age: "5m", quote: "USDT", price: "$0.04261", mc: "$3.58M", change: "-4.39%", up: false, img: avatar("Zatoshi") },
  { symbol: "ZOL", name: "Zolana", age: "6m", quote: "BNB", price: "$0.0₄4693", mc: "$46.94K", change: "+32.07%", up: true, img: avatar("Zolana") },
  { symbol: "KOSH", name: "Kosher Inu", age: "8m", quote: "BTCB", price: "$0.029802", mc: "$1.24M", change: "+38.96%", up: true, img: avatar("Kosher") },
  { symbol: "WIZ", name: "The Wizards", age: "9m", quote: "BNB", price: "$0.001628", mc: "$1.18M", change: "+90.22%", up: true, img: avatar("Wizards") },
  { symbol: "SEB", name: "Zebra", age: "9m", quote: "USDT", price: "$0.0₄4738", mc: "$47.39K", change: "-11.9%", up: false, img: avatar("Zebra") },
  { symbol: "SHLD", name: "Shielded", age: "10m", quote: "BNB", price: "$0.001453", mc: "$1.41M", change: "+13.08%", up: true, img: avatar("Shielded") },
  { symbol: "ORCH", name: "Orchard", age: "12m", quote: "BNB", price: "$0.0₃6485", mc: "$648.54K", change: "+49.52%", up: true, img: avatar("Orchard") },
  { symbol: "SPRT", name: "Sprout", age: "14m", quote: "USDT", price: "$0.097867", mc: "$97.83M", change: "+4%", up: true, img: avatar("Sprout") },
  { symbol: "HALO", name: "Halo Arc", age: "18m", quote: "BNB", price: "$0.001309", mc: "$1.31M", change: "+635.6%", up: true, img: avatar("Halo") },
  { symbol: "NULL", name: "Null Set", age: "21m", quote: "BTCB", price: "$0.10578", mc: "$105.78M", change: "-3.6%", up: false, img: avatar("NullSet") },
];

export const burns = [
  { when: "6h ago", coin: "STAMP", destroyed: 1500000, burner: "0x26oK…GtYA", cert: "t1P2GcxGhzeM5tPk3r3JsGh1tEVArD4C2fB", tx: "0x9a4f2c8b7e1d5a3f6c0b9e8d7a2f1c4b" },
  { when: "11h ago", coin: "ZEAL", destroyed: 2000000, burner: "0x7bC1…9fE0", cert: "t1a9Fk2mQ8xR4vN6cWpLdE3sBhJ7tYzUq2", tx: "0x3d8a0f5c2b7e9d1a4f6c3b8e0d5a2f1c" },
  { when: "1d ago", coin: "ZOL", destroyed: 1000000, burner: "0x9F2a…C7fF", cert: "t1KpR3nX7mB2vLq9dFsW4eH8cJ6tYzA1uP", tx: "0x6e3d8a0f5c2b7e9d1a4f6c3b8e0d5a2f" },
  { when: "2d ago", coin: "STAMP", destroyed: 3200000, burner: "0xCaA7…6a83", cert: "t1M4nP8xK2rB7vLq5dFsW9eH3cJ6tYzB2v", tx: "0x1a4f6c3b8e0d5a2f9a4f2c8b7e1d5a3f" },
  { when: "3d ago", coin: "WIZ", destroyed: 1750000, burner: "0x08fF…D490", cert: "t1QrT6vX9mB4nLq2dFsW7eH1cJ8tYzC3w", tx: "0x8e0d5a2f1c4b6e3d8a0f5c2b7e9d1a4f" },
];

export const totalStats = {
  totalDestroyed: 9450000,
  certificates: 5,
  inscriptionsOnZcash: 113000,
};

export const verifyCards = {
  valid: {
    status: "VALID",
    text: "1,500,000 destroyed on BNB Chain, recorded on Zcash, delivered to the address that burned it.",
    inscription: "b2cbded5c37c2cca8918a077a73e2ca349005efba046cee0866b34dd879c5acb",
    burn: "0x9a4f2c8b7e1d5a3f6c0b9e8d7a2f1c4b6e3d8a0f5c2b7e9d1a4f6c3b8e0d5a2f",
  },
  refused: {
    status: "REFUSED",
    text: "Signed with our own key, claiming ten times the amount, citing a burn that never happened. Zcash accepted the inscription. The rule does not: it names no real burn, so it is not a certificate and never counts.",
    inscription: "d54660626ac2464cdaac7009e5b0b93f8b705e6236b24455edde8a34faffc0b7",
  },
};
